var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIncomingCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51378 9.04093H3.50596C2.04096 9.36642 0.998961 10.6663 1 12.167V12.7999C1 13.0828 1.11238 13.3541 1.31242 13.5541C1.51246 13.7541 1.78377 13.8665 2.06667 13.8665H4.73333C5.32244 13.8665 5.8 13.389 5.8 12.7999V12.7999C5.8 12.2108 6.27756 11.7332 6.86667 11.7332H11.1333C11.7224 11.7332 12.2 12.2108 12.2 12.7999V12.7999C12.2 13.389 12.6776 13.8665 13.2667 13.8665H15.9333C16.5224 13.8665 17 13.389 17 12.7999V12.167C17 10.6671 15.9583 9.36838 14.494 9.04306H14.4862C10.8625 8.34118 7.13779 8.34046 3.51378 9.04093V9.04093Z",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.86663V2.1333",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26699 5.86662L3.66699 3.19995",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7334 5.86662L14.3334 3.19995",
    stroke: "#242424",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIncomingCallIcon);
export default __webpack_public_path__ + "static/media/phone-incoming-call-icon.aea050407f66f4ce71f6bcd116f53ebf.svg";
export { ForwardRef as ReactComponent };